// Copyright Contributors to the Packit project.
// SPDX-License-Identifier: MIT

import { MissingPage } from "@patternfly/react-component-groups";

export const NotFoundCard = () => <MissingPage />;
